import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TabNotificationService } from 'src/shared/services/tab-notification.service/tab-notification.service';

@Injectable({ providedIn: 'root' })
export class AppTitleService {
  private title = inject(Title);
  private tabNotificationService = inject(TabNotificationService);

  private pageTitle = 'Joii PMS';
  private queueCount = 0;

  setPageTitle(title: string) {
    this.pageTitle = title;
    this.update();
  }

  setQueueCount(count: number) {
    this.queueCount = count;
    this.tabNotificationService.unreadCount.set(count);
    this.update();
  }

  private update() {
    const queuePrefix = this.queueCount ? `(${this.queueCount}) ` : '';

    this.title.setTitle(`${queuePrefix}${this.pageTitle}`);
  }
}
